import { useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import createRedshiftCluster from 'api/RedshiftCluster/createCluster';
export interface NewClusterInput {
    label: string;
    description: string;
    nodeType: string;
    numberOfNodes: string;
    masterDatabaseName: string;
    databaseName: string;
    vpc: string;
    authorized_resources: string;
    tags?: string[];
    SamlGroupName: string;
}
export default function useCreateCluster() {
    const client = useClient();

    const { openAlert } = useAlert();

    const [buttonLoading, setButtonLoading] = useState(false);

    const handleSubmit = async (
        environmentUri: string,
        pipeline: NewClusterInput,
    ) => {
        setButtonLoading(true);

        const response = await client.mutate(
            createRedshiftCluster(environmentUri, pipeline),
        );
        if (!response.errors) {
            openAlert({
                path: `warehouse/${response.data.createRedshiftCluster.clusterUri}`,
                message: `Redshift Cluster successfully created`,
                severity: 'success',
            });
        } else {
            openAlert({
                message: `Something went wrong... Could not create Redshift cluster.  ${response.errors[0].message}`,
                severity: 'alert',
            });
        }

        setButtonLoading(false);
    };

    return { buttonLoading, handleSubmit };
}
